import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import PersonalNotesPanel from "./PersonalNotesPanel";
import {
  PersonalNote,
  PersonalNoteTargetType,
} from "../../models/personalNote";
import { MeetingItem } from "../../models/meetingItem";

interface PersonalNotesModalProps {
  open: boolean;
  onClose: () => void;
  targetType: PersonalNoteTargetType;
  targetId: string | null;
  targetItem?: MeetingItem | null;
  onNotesChange: (notes: PersonalNote[]) => void;
}

const PersonalNotesModal = ({
  open,
  onClose,
  targetType,
  targetId,
  targetItem,
  onNotesChange,
}: PersonalNotesModalProps) => {
  const { t } = useTranslation();
  const [dialogEntered, setDialogEntered] = useState(false);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      slotProps={{
        transition: {
          onEntered: () => setDialogEntered(true),
          onExited: () => setDialogEntered(false),
        },
        paper: {
          sx: {
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: "0px 18px 42px rgba(15, 23, 42, 0.14)",
          },
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        {t("meetingNotes.personalNotes.title")}
        {targetItem ? (
          <Typography sx={{ mt: 0.5, fontSize: "0.875rem", color: "#64748B" }}>
            {targetItem.description || targetItem.content}
          </Typography>
        ) : null}
      </DialogTitle>
      <DialogContent sx={{ pt: "12px !important" }}>
        <PersonalNotesPanel
          targetType={targetType}
          targetId={targetId}
          onNotesChange={onNotesChange}
          dialogEntered={dialogEntered}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ textTransform: "none", color: "#64748B" }}
        >
          {t("button.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PersonalNotesModal;
